<div id="crm-company-google-place-name-form" *ngIf="readOnly; else formField">
  <div class="crm-field-label">{{ label }}</div>
  <div class="crm-field-value">
    <!-- ng-container necessary since Angular interpolation will add empty space -->
    <ng-container *ngIf="value as Name; else loading">
      <ng-container *ngIf="Name !== NO_VALUE_FOR_NAME">
        {{ Name }}
      </ng-container>
    </ng-container>
    <ng-template #loading>
      <div class="stencil-shimmer"></div>
    </ng-template>
  </div>
</div>
<ng-template #formField>
  <google-map
    style="display: none"
    [options]="{ fullscreenControl: false, mapTypeControl: false }"
    (mapInitialized)="onMapReady($event)"
  ></google-map>
  <glxy-form-field>
    <glxy-label>{{ label }}</glxy-label>
    <input
      id="companyName"
      name="companyName"
      required
      matInput
      [formControl]="control"
      [matAutocomplete]="auto"
      (keyup)="companyOnFieldChange($event)"
      data-testid="companyName-input"
    />
    <mat-error *ngIf="control?.dirty && control?.hasError('required')">
      {{ 'STANDARD_FIELD_RULES.COMPANY.COMPANY_NAME_REQUIRED' | translate }}
    </mat-error>
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="companyDisplayValue"
      (optionSelected)="companyOnSelected($event.option.value)"
      class="company-options"
    >
      <mat-option
        [ngClass]="{
          'autocomplete-suggestion': true,
          'suggestion-not-found': isLast
        }"
        *ngFor="let location of locations; last as isLast"
        [value]="location"
      >
        <span class="main-text">{{ location.mainText }}</span>
        <br />
        <span class="secondary-text">{{ location.secondaryText }}</span>
      </mat-option>
    </mat-autocomplete>
  </glxy-form-field>
</ng-template>
